import { useContext } from 'react';
import { FeatureFlagContext } from '../contexts/FeatureFlagContext';
import { FeatureKey } from '../constants/features';

// ----------------------------------------------------------------------

const useFeature = (feature: FeatureKey) => {
  const context = useContext(FeatureFlagContext);

  if (!context) throw new Error('useFeature must be used inside FeatureFlagProvider');

  return {
    isEnabled: context.isFeatureEnabled(feature),
    isLoaded: context.isLoaded,
  };
};

export default useFeature;
